import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useScrollPosition } from '../hooks/useScrollPosition';
const logo = "/other-images/logo.png";
const archibimLogo = "/other-images/archibimwhite.png";

const Navbar: React.FC = () => {
  const location = useLocation();
  const scrollY = useScrollPosition();
  
  // Determine if we're on the main page
  const isMainPage = location.pathname === '/';
  
  // For main page: transparent when at top, background when scrolled
  // For other pages: always have background
  const shouldHaveBackground = !isMainPage || scrollY > 50;
  
  const navbarClasses = `navbar ${shouldHaveBackground ? 'navbar-scrolled' : 'navbar-transparent'}`;

  return (
    <nav className={navbarClasses}>
      <div className="navbar-left">
        <Link to="/" className="logo-link">
          <img src={logo} alt="DSarchitekt Logo" className="navbar-logo" />
        </Link>
        <ul className="nav-links">
          <li><Link to="/">Úvod</Link></li>
          <li><Link to="/about">O Mě</Link></li>
        </ul>
      </div>
      <div className="navbar-right">
        <span className="archibim-text">
        Všechny projekty<br />
        spolurealizovány s
        </span>
        <a href="http://archibim.cz/" target="_blank" rel="noopener noreferrer" className="logo-link">
          <img src={archibimLogo} alt="ArchiBIM Logo" className="navbar-logo archibim-logo" />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
